
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as bugX5ej5dnFlhWihwKfYZknvf47h77qmm3koQsREtLdIXYMeta } from "/app/pages/bug.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta } from "/app/pages/login.vue?macro=true";
import { default as resultsyB93ixl3Yr1oI_457aS7KDcM0SRql7_454IQQmTEwW1oJvgMeta } from "/app/pages/results.vue?macro=true";
import { default as indexo3Z7akWjnnj4wiAHkCLNrUJE8lFaCUdduuWOIMV7VcgMeta } from "/app/pages/radar/index.vue?macro=true";
import { default as unauthorized17NYwdK_vpXoMmVXmhdTSn6CG_AM5wMHLBy01ScJbgcMeta } from "/app/pages/unauthorized.vue?macro=true";
import { default as _91route_938L2HfnpjGe6sJPBMaGGl8eICjmB7q9UvM_453Rn5RWxuIMeta } from "/app/pages/radar/[route].vue?macro=true";
import { default as _91id_93caBcbv2zcbPhPx25KkUUwKvBn_454tbprFJGvWHuZu6B0Meta } from "/app/pages/automations/[id].vue?macro=true";
import { default as index4lFmUlg8AjOnrIXSJmeZrIdbA_45wH0uYwUx_45aXiPIzScMeta } from "/app/pages/automations/index.vue?macro=true";
export default [
  {
    name: "bug",
    path: "/bug",
    component: () => import("/app/pages/bug.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "results",
    path: "/results",
    component: () => import("/app/pages/results.vue")
  },
  {
    name: "radar",
    path: "/radar",
    component: () => import("/app/pages/radar/index.vue")
  },
  {
    name: "unauthorized",
    path: "/unauthorized",
    component: () => import("/app/pages/unauthorized.vue")
  },
  {
    name: "radar-route",
    path: "/radar/:route()",
    component: () => import("/app/pages/radar/[route].vue")
  },
  {
    name: "automations-id",
    path: "/automations/:id()",
    component: () => import("/app/pages/automations/[id].vue")
  },
  {
    name: "automations",
    path: "/automations",
    component: () => import("/app/pages/automations/index.vue")
  }
]